
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import MobileProContent from "../Components/MobileProContent";

const MobilePro = () => {
  const seoData = getSEOData("/mobilepro");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <MobileProContent />
    </>
  );
};

export default MobilePro;
